module.exports = __webpack_public_path__ + "img/rbonner.515ac4af.png";